import { useEffect, useRef, useState } from 'react';
import { isIOS } from 'react-device-detect';

import { Button } from '@thefarmersfront/kitchen-mobile';

import { TypeAppInstallLink, useGetAppInstallLink } from '../../hooks';
import { GUIDE_MESSAGES } from '~/constants';
import { useCodesStore, useTokenStore, useUserInfoStore, useWorkInfoStore } from '~/store';

import { EmptyText } from '../shared';

import styles from './AppInstallGuide.module.scss';

/** @description 앱 설치 가이드 컴포넌트 */
const AppInstallGuide = () => {
  const [appInstallLink, setAppInstallLink] = useState<TypeAppInstallLink>({
    ios: '',
    aos: '',
  });

  const requestGetAppInstallLink = useGetAppInstallLink();

  const resetUserInfo = useUserInfoStore((state) => state.actions.resetUserInfo);
  const resetTokens = useTokenStore((state) => state.actions.resetTokens);
  const resetWorkInfo = useWorkInfoStore((state) => state.actions.resetWorkInfo);
  const resetCodes = useCodesStore((state) => state.actions.resetCodes);

  const timerId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timerId.current = setTimeout(() => {
      resetUserInfo();
      resetTokens();
      resetWorkInfo();
      resetCodes();
    }, 1000);

    requestGetAppInstallLink({
      onSuccess: (response) => {
        setAppInstallLink(response.data);
      },
    });

    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
        timerId.current = null;
      }
    };
  }, []);

  const handleInstallApp = () => {
    if (isIOS) {
      window.open(appInstallLink.ios);
      return;
    }
    window.open(appInstallLink.aos);
  };

  return (
    <div className={styles['app-install-guide-container']}>
      <EmptyText
        text={GUIDE_MESSAGES.INVALID_PATH}
        bottomElement={
          <Button size="medium" className={styles['app-install-guide-button']} onClick={handleInstallApp}>
            앱으로 보기
          </Button>
        }
      />
    </div>
  );
};

export default AppInstallGuide;
